"use client";

import { useNavigationStore } from "@/store/navigation";

// Pages
import PublicGames from "@/components/pages/PublicGames";
import CreateGame from "@/components/pages/CreateGame";
import QuizEditor from "@/components/pages/QuizEditor";
import SituationEditor from "@/components/pages/SituationEditor";

export default function Home() {
  const { activePage, setActivePage } = useNavigationStore();

  return (
    <div className="font-sans flex flex-col h-full w-full relative bg-[#F4F2E5] overflow-hidden p-7.5">
      {activePage === "/public-games" && <PublicGames />}
      {activePage === "/create-game" && <CreateGame />}
      {activePage === "/create-game/quiz" && <QuizEditor onBack={() => setActivePage("/create-game")} />}
      {activePage === "/create-game/situation" && <SituationEditor onBack={() => setActivePage("/create-game")} />}
    </div>
  );
}
